module.exports = __webpack_public_path__ + "img/thumb-abby.4ab5d09f.png";